import { get } from 'lodash';
import { mapActions, mapState } from 'pinia';
import Interactions from 'src/mixins/Interactions';
import { auth } from 'src/store/auth';
import { logEvent } from 'src/utils/LogEvent';

export default {
  computed: {
    ...mapState(auth, ['userDetails', 'provider', 'userPrivileges', 'ssoProviders', 'billing',
      'lockedPrivileges', 'defaultPrivileges']),
  },

  mixins: [Interactions],

  methods: {
    ...mapActions(auth, ['logout']),

    userHasPrivilege(privilege) {
      const userRole = get(this.userDetails, 'role');

      if (get(this.lockedPrivileges, [userRole, privilege], false)) {
        return get(this.defaultPrivileges, [userRole, privilege], false);
      }

      return get(
        this.userPrivileges,
        privilege,
        get(this.defaultPrivileges, [userRole, privilege], false),
      );
    },

    /**
     * Check if a specific role has a specific privilege. Requires user privileges
     * to be loaded.
     * @param {*} userPrivileges Object of user privileges (keyed by role)
     * @param {*} userRole
     * @param {*} privilege
     * @returns
     */
    roleHasPrivilege(userPrivileges, userRole, privilege) {
      if (get(this.lockedPrivileges, [userRole, privilege], false)) {
        return get(this.defaultPrivileges, [userRole, privilege], false);
      }
      return get(
        userPrivileges,
        [userRole, privilege],
        get(this.defaultPrivileges, [userRole, privilege], false),
      );
    },

    async signOut(fromLoader = false) {
      try {
        await this.logout();
      } catch (err) {
        console.error('Sign out failed', err);
        logEvent(err);
        this.notifyNegative(this.$t('common.errors.signOutError', { error: err?.message || String(err) }));
      }

      const logoutQuery = fromLoader ? this.$route.query.redirect : '';

      this.$router.push({
        name: 'login',
        query: { ...this.$route.query, redirect: logoutQuery },
      }).catch((err) => {
        logEvent(err, {
          context: {
            redirect_data: { route: this.$route },
          },
        });
      });
    }, // signOut()
  },
};
